import { fileActions } from 'core/File';
import { useTranslation } from 'react-i18next';
import {
    ActionButton,
    Container,
    Text
} from './styled';
import {
    ExpandButton,
    Input,
    MaterialIcon
} from 'mol-ui';
import React, { useEffect, useState } from 'react';
import {
    useDispatch,
    useInput,
    useSelector
} from 'hooks';

const NewFolder = ({

}) => {

    const dispatch = useDispatch();
    const { t } = useTranslation();
    const {
        blocked,
        status
    } = useSelector('file');
    const {
        selected: {
            id: patient_id
        }
    } = useSelector('patient');

    const [creating, setCreating] = useState(false);
    const [error, setError] = useState(false);
    const [nameInput, name, setName] = useInput('', {}, () => setError(false));

    useEffect(() => {
        if (status === 'folder-created' && creating) {
            setCreating(false);
            dispatch(fileActions.setFileStatus(''));
        }
    }, [status]);

    const cancelCreation = () => {
        setCreating(false);
        setName('');
    };

    const handleFolderToggle = () => {
        if (!blocked) {
            setCreating(true);
        }
    };

    const handleCreation = () => {
        if (validate()) {
            const data = {
                name,
                patient_id
            };
            dispatch(fileActions.createFolder(data));
            setName('');
        }
    };

    const validate = () => {
        const newError = !name;
        setError(newError);
        return !newError;
    };
    
    return (
        <Container>
            {
                !creating
                    ? <ActionButton onClick={ handleFolderToggle }>
                        <MaterialIcon icon="create_new_folder" size={ 22 } />
                        <Text>
                            { t('Agregar nuevo carpeta') }...
                        </Text>
                    </ActionButton>
                    : <>
                        <MaterialIcon icon="create_new_folder" size={ 22 } />
                        <Input
                            { ...nameInput }
                            disabled={ blocked }
                            error={ error }
                            fontSize="12px"
                            height="15px"
                            margin="0px 5px"
                            width="200px"
                        />
                        <ExpandButton
                            circle
                            danger
                            disabled={ blocked }
                            icon="close"
                            margin="0px 10px"
                            size={ 20 }
                            onClick={ cancelCreation }
                        />
                        <ExpandButton
                            circle
                            disabled={ blocked }
                            icon="check"
                            loading={ status === 'folder-creating' }
                            size={ 20 }
                            onClick={ handleCreation }
                        />
                    </>
            }
        </Container>
    );
};

NewFolder.propTypes = {

};

export default NewFolder;
